var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
export function Paragraph(props) {
    var children = props.children, className = props.className, lead = props.lead, subLead = props.subLead, textCenter = props.textCenter, textLeft = props.textLeft, noMargin = props.noMargin, rest = __rest(props, ["children", "className", "lead", "subLead", "textCenter", "textLeft", "noMargin"]);
    var mainClass = [
        lead && 'ffe-lead-paragraph',
        subLead && 'ffe-sub-lead-paragraph',
        'ffe-body-paragraph',
    ].filter(Boolean)[0];
    return (React.createElement("p", __assign({ className: classNames(mainClass, { 'ffe-body-paragraph--text-center': textCenter }, { 'ffe-body-paragraph--text-left': textLeft }, { 'ffe-body-paragraph--no-margin': noMargin }, className) }, rest), children));
}
